import { createSlice } from "@reduxjs/toolkit";
import { ADVISORY_BOARD } from "../../db/data.js";


//const initialState =  { advisory: ADVISORY_BOARD };
const initialState =  { advisory: [] };

export const advisorySlice = createSlice({
    name: "advisory",
    initialState,
    reducers : {
        loadAdvisory : (state, action) => {
            state.advisory =  ADVISORY_BOARD;
        },
        addAdvisory : (state, action) => {
            state.advisory.push(action.payload);
        }
    }
});

export default advisorySlice.reducer;  //slice reducer

export const { loadAdvisory, addAdvisory } = advisorySlice.actions ;  // action creators

//export Selectors
export const selectAdvisory = (state) => state.advisory ; //select advisory slice.

